(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function openRowFromHash(hash, smooth) {
      if (!hash || hash.length < 2) return false;
      var id = decodeURIComponent(hash.slice(1)).toLowerCase();
      var target = document.getElementById(id);
      if (!target || target.tagName !== 'DETAILS') return false;
      target.open = true;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      return true;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="#"]');
      if (!link) return;
      var url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname) return;
      var id = decodeURIComponent(url.hash.slice(1)).toLowerCase();
      if (openRowFromHash(url.hash, true)) {
        event.preventDefault();
      } else if (id === 'size-guide') {
        event.preventDefault();
        window.location.href = '/pages/size-guide';
      }
    });

    window.addEventListener('load', function () {
      openRowFromHash(window.location.hash, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
